'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _DateRangePicker = require('component-datepicker/dist/components/DateRangePicker');

var _DateRangePicker2 = _interopRequireDefault(_DateRangePicker);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var optionalDatepickerProps = {
	className: 'customDates',
	inputClassName: 'vx_form-control vx_form-control_complex form-control',
	dayClassName: 'day'
};

var DateRanger = function (_React$Component) {
	_inherits(DateRanger, _React$Component);

	function DateRanger(props) {
		_classCallCheck(this, DateRanger);

		var _this = _possibleConstructorReturn(this, (DateRanger.__proto__ || Object.getPrototypeOf(DateRanger)).call(this, props));

		_this.localObj = {
			editingInput: '',
			render: true,
			fromDate: '',
			toDate: '',
			datePattern: _this.props.datePattern || 'MM/DD/YYYY',
			isEndDate: false
		};
		var dateLabels = _this.props.texts || {};
		_this.state = {
			startDate: new Date(),
			initialDate: new Date(),
			endDate: new Date(),
			currentMonth: (0, _moment2.default)().utc().toDate(),
			showing: false,
			minFromDate: new Date(0),
			maxFromDate: new Date(),
			maxEndDate: new Date(),
			rangeDate1: new Date(0),
			rangeDate2: new Date(),
			texts: {
				startDate: dateLabels.dp_startDate || 'start',
				endDate: dateLabels.dp_endDate || 'end',
				datePatternPlaceholder: _this.localObj.datePattern,
				'week-1': dateLabels.dp_week_1 || 'Mon',
				'week-2': dateLabels.dp_week_2 || 'Tue',
				'week-3': dateLabels.dp_week_3 || 'Wed',
				'week-4': dateLabels.dp_week_4 || 'Thr',
				'week-5': dateLabels.dp_week_5 || 'Fri',
				'week-6': dateLabels.dp_week_6 || 'Sat',
				'week-7': dateLabels.dp_week_7 || 'Sun'
			}
		};

		_this.openDatepicker = _this.openDatepicker.bind(_this);
		_this.onChangeMonth = _this.onChangeMonth.bind(_this);
		_this.onClickMonthName = _this.onClickMonthName.bind(_this);
		_this.onClickClose = _this.onClickClose.bind(_this);
		_this.onClickNext = _this.onClickNext.bind(_this);
		_this.onClickPrev = _this.onClickPrev.bind(_this);
		_this.onDateRangePickerClickDay = _this.onDateRangePickerClickDay.bind(_this);
		_this.dateRangePickerIsWithinRange = _this.dateRangePickerIsWithinRange.bind(_this);
		_this.onDateRangePickerClickShortcut = _this.onDateRangePickerClickShortcut.bind(_this);
		_this._formatDate = _this._formatDate.bind(_this);
		_this.checkUserDate = _this.checkUserDate.bind(_this);
		_this.checkDefaultBehavior = _this.checkDefaultBehavior.bind(_this);
		_this.handleClickAway = _this.handleClickAway.bind(_this);

		_this.shortcuts = [{
			label: dateLabels.lastMonth || 'Last month',
			className: 'nemo_datePickerPreset0',
			id: 'lastmonth'
		}, {
			label: dateLabels.last90days || 'Last 90 days',
			className: 'nemo_datePickerPreset1',
			id: 'last90'
		}];
		return _this;
	}

	_createClass(DateRanger, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			this.localObj.render = false;
		}
	}, {
		key: 'componentWillUpdate',
		value: function componentWillUpdate(nextProps, nextState) {
			if ((0, _jquery2.default)('#filters-endDate').val().length === 0) {
				this.localObj.isEndDate = true;
			} else {
				this.localObj.isEndDate = false;
			}
		}
	}, {
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps, nextState) {
			var flag = false;
			if (this.localObj.render) {
				flag = true;
			} else {
				this.localObj.render = true;
				flag = false;
			}
			return flag;
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (this.localObj.isEndDate) {
				(0, _jquery2.default)('#filters-endDate').val('');
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.checkDefaultBehavior();
			(0, _jquery2.default)('#filters-endDate').prop('disabled', true);
			(0, _jquery2.default)('#filters-endDate').addClass('disabled');
			(0, _jquery2.default)('#filters-endDate,#filters-startDate').prop('autocomplete', 'off');

			var self = this;
			var datePattern = self.localObj.datePattern;
			(0, _jquery2.default)('#filters-startDate').blur(function () {
				var fromDateInput = self.localObj.fromDate;
				if (fromDateInput.length) {
					var isValidDate = (0, _moment2.default)(fromDateInput, datePattern, true).isValid();
					if (isValidDate) {
						var day = (0, _moment2.default)(fromDateInput).utc().toDate();
						self.setState({
							startDate: day
						}, function () {
							(0, _jquery2.default)('#filters-endDate').prop('disabled', false);
							(0, _jquery2.default)('#filters-endDate').removeClass('disabled');
							self.props.updateFromDate(day);
						});
					}
				}
				if (fromDateInput.length === 0) {
					self.checkDefaultBehavior();
				}
			});

			(0, _jquery2.default)('#filters-endDate').blur(function () {
				var toDateInput = self.localObj.toDate;
				if (toDateInput.length) {
					var isValidDate = (0, _moment2.default)(toDateInput, datePattern, true).isValid();
					if (isValidDate) {
						(0, _jquery2.default)('#filters-endDate').val('1'); // duplicate value
						var day = (0, _moment2.default)(toDateInput).utc().toDate();
						self.setState({
							endDate: day
						});
						self.props.updateEndDate(day);
					}
				}
				if (toDateInput.length === 0) {
					self.checkDefaultBehavior();
				}
			});
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			var self = this;
			var monthsTexts = self.props.texts || {};
			_moment2.default.updateLocale('en', {
				months: [monthsTexts.dp_month_1 || 'Jan', monthsTexts.dp_month_2 || 'Feb', monthsTexts.dp_month_3 || 'Mar', monthsTexts.dp_month_4 || 'Apr', monthsTexts.dp_month_5 || 'May', monthsTexts.dp_month_6 || 'June', monthsTexts.dp_month_7 || 'July', monthsTexts.dp_month_8 || 'Aug', monthsTexts.dp_month_9 || 'Sep', monthsTexts.dp_month_10 || 'Oct', monthsTexts.dp_month_11 || 'Nov', monthsTexts.dp_month_12 || 'Dec']
			});
		}
	}, {
		key: 'checkUserDate',
		value: function checkUserDate(event) {
			var self = this;
			if (event) {
				event.preventDefault();
				event.stopPropagation();

				if (self.localObj.editingInput === 'start') {
					self.localObj.fromDate = event.target.value;
				}

				if (self.localObj.editingInput === 'end') {
					self.localObj.toDate = event.target.value;
				}
			}
		}
	}, {
		key: 'openDatepicker',
		value: function openDatepicker(element, _ref) {
			var _this2 = this;

			var behavior = _ref.behavior,
			    date = _ref.date;


			element.preventDefault();
			element.stopPropagation();

			this.localObj.editingInput = behavior;
			if (behavior === 'start') {
				(0, _jquery2.default)('.date-picker-box-tip').removeClass('end-date-picker-box-tip');
				this.setState({
					showing: true,
					currentMonth: date,
					rangeDate1: this.state.minFromDate,
					rangeDate2: this.state.maxFromDate
				}, function () {
					_this2.checkDefaultBehavior();
				});
			} else if (behavior === 'end') {
				(0, _jquery2.default)('.date-picker-box-tip').addClass('end-date-picker-box-tip');
				this.setState({
					showing: true,
					currentMonth: date,
					rangeDate1: this.state.startDate,
					rangeDate2: this.state.maxEndDate
				}, function () {
					_this2.checkDefaultBehavior();
				});
			}
		}
	}, {
		key: 'checkDefaultBehavior',
		value: function checkDefaultBehavior() {
			if (this.state.startDate.toString() === this.state.initialDate.toString()) {
				(0, _jquery2.default)('#filters-startDate').val('');
				(0, _jquery2.default)('#filters-endDate').val('');
			}
		}
	}, {
		key: 'onChangeMonth',
		value: function onChangeMonth(element, date) {
			this.setState({
				currentMonth: date
			});
		}
	}, {
		key: 'onClickMonthName',
		value: function onClickMonthName(element) {
			var _this3 = this;

			var startDate = (0, _moment2.default)(this.state.currentMonth).startOf('month').toDate(),
			    endDate = (0, _moment2.default)(this.state.currentMonth).endOf('month').toDate();
			(0, _jquery2.default)('#filters-endDate').val('1'); // duplicate value
			this.setState({
				startDate: startDate,
				endDate: endDate
			}, function () {
				(0, _jquery2.default)('#filters-endDate').prop('disabled', false);
				(0, _jquery2.default)('#filters-endDate').removeClass('disabled');
				_this3.props.updateFromDate(startDate);
				_this3.props.updateEndDate(endDate);
			});
		}
	}, {
		key: 'onClickClose',
		value: function onClickClose(element) {
			element.preventDefault();
			element.stopPropagation();
			this.handleClickAway();
		}
	}, {
		key: 'onClickPrev',
		value: function onClickPrev(event, showMonth) {
			if (!(0, _moment2.default)(showMonth).endOf('month').isBefore(this.state.minFromDate)) {
				this.setState({
					currentMonth: showMonth
				});
			}
		}
	}, {
		key: 'onClickNext',
		value: function onClickNext(event, showMonth) {
			if (!(0, _moment2.default)(showMonth).startOf('month').isAfter(this.state.maxFromDate)) {
				this.setState({
					currentMonth: showMonth
				});
			}
		}
	}, {
		key: 'dateRangePickerIsWithinRange',
		value: function dateRangePickerIsWithinRange(_ref2, date) {
			var minDate = _ref2.minDate,
			    maxDate = _ref2.maxDate;

			// the '[]' indicates inclusive on both sides, per Moment docs
			return (0, _moment2.default)(date).isBetween(minDate, maxDate, 'day', '[]');
		}
	}, {
		key: 'onDateRangePickerClickDay',
		value: function onDateRangePickerClickDay(event, day) {
			var _this4 = this;

			if (!day.valid) {
				return false;
			}
			var thisDay = (0, _moment2.default)(day.date);

			if (this.localObj.editingInput === 'start') {
				this.setState({
					startDate: day.date
				}, function () {
					(0, _jquery2.default)('#filters-endDate').prop('disabled', false);
					(0, _jquery2.default)('#filters-endDate').removeClass('disabled');
					_this4.props.updateFromDate(thisDay);
				});
			}
			if (this.localObj.editingInput === 'end') {
				(0, _jquery2.default)('#filters-endDate').val('1'); // duplicate value
				this.setState({
					endDate: day.date
				}, function () {
					_this4.props.updateEndDate(thisDay);
				});
			}
			return true;
		}
	}, {
		key: 'onDateRangePickerClickShortcut',
		value: function onDateRangePickerClickShortcut(event, presetName) {
			event.preventDefault();
			event.stopPropagation();
			(0, _jquery2.default)('#filters-endDate').val('1'); // duplicate value
			(0, _jquery2.default)('#filters-endDate').prop('disabled', false);
			(0, _jquery2.default)('#filters-endDate').removeClass('disabled');
			this.dateRangePickerPublish.apply(this, [this, event].concat(_toConsumableArray(this.dateRangePickerGetShortcutPresets()[presetName]())));
		}
	}, {
		key: 'handleClickAway',
		value: function handleClickAway() {
			var _this5 = this;

			if (!(this.state.startDate.toString() === this.state.initialDate.toString())) {
				(0, _jquery2.default)('#filters-endDate').val('1'); // duplicate value
			}
			this.setState({
				showing: false
			}, function () {
				_this5.props.updateEndDate(_this5.state.endDate);
				_this5.checkDefaultBehavior();
			});
		}
	}, {
		key: 'dateRangePickerPublish',
		value: function dateRangePickerPublish(component, event, startDate, endDate) {
			var _this6 = this;

			this.setState({
				startDate: startDate,
				endDate: endDate,
				showing: false
			}, function () {
				_this6.props.updateFromDate(startDate);
				_this6.props.updateEndDate(endDate);
			});
		}
	}, {
		key: 'dateRangePickerGetShortcutPresets',
		value: function dateRangePickerGetShortcutPresets() {
			return {
				lastmonth: function getLastMonthDateRange() {
					var start = (0, _moment2.default)().subtract(1, 'months').startOf('month').toDate();
					var end = (0, _moment2.default)().subtract(1, 'months').endOf('month').toDate();
					return [start, end];
				},
				last90: function getLast90DaysDateRange() {
					var start = (0, _moment2.default)().subtract(90, 'days').toDate();
					var end = (0, _moment2.default)().toDate();
					return [start, end];
				}
			};
		}
	}, {
		key: '_formatDate',
		value: function _formatDate(format, date) {
			return (0, _moment2.default)(date).format(format);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this7 = this;

			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(_DateRangePicker2.default, _extends({
					showing: this.state.showing,
					startDate: this.state.startDate,
					endDate: this.state.endDate,
					labels: this.state.texts,
					showMonth: this.state.currentMonth,
					formatDate: function formatDate(date) {
						return (0, _moment2.default)(date).format(_this7.localObj.datePattern);
					},
					onFocusInput: this.openDatepicker,
					onClickNext: this.onClickNext,
					onClickPrev: this.onClickPrev,
					onClickMonthName: this.onClickMonthName // set selected date as whole month
					, onClickClose: this.onClickClose,
					onHoverDay: function onHoverDay(e) {},
					onClickDay: this.onDateRangePickerClickDay,
					className: 'vx_form-group customDates-icon',
					onInputChange: this.checkUserDate,
					nameSpace: 'customDates',
					getActiveShortcut: function getActiveShortcut() {
						return '';
					},
					onClickAway: this.handleClickAway,
					shortcuts: this.shortcuts,
					formatMonthHeader: function formatMonthHeader(date) {
						return _this7._formatDate('MMMM YYYY', date);
					},
					validateDate: function validateDate(date) {
						return _this7.dateRangePickerIsWithinRange({
							minDate: _this7.state.rangeDate1,
							maxDate: _this7.state.rangeDate2
						}, date);
					},
					onClickShortcut: this.onDateRangePickerClickShortcut
				}, optionalDatepickerProps))
			);
		}
	}]);

	return DateRanger;
}(_react2.default.Component);

DateRanger.propTypes = {
	datePattern: _react.PropTypes.string,
	texts: _react.PropTypes.object,
	updateFromDate: _react.PropTypes.func,
	updateEndDate: _react.PropTypes.func
};

exports.default = DateRanger;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/ppgf-components/dist/components/dateRanger.js
// module id = 503
// module chunks = 0